<template>
  <div class="upload-box">
    <div class="upload-btn" id="uploadBtnDivVM">
          <ejs-button class="e-input" isPrimary='true' @click.native='upButton' >{{$t("Common.upload")}}</ejs-button>
    </div>
    <progress-bar v-show='showProgressBar' ref='progressBar' :val='progressVal' :text='progressText' class="upload-progress"></progress-bar>
    <div class='h-system-hide-upload'>
      <ejs-uploader ref='file' name='file' id='file' autoUpload='false' :selected='onFileSelect'
                    :allowedExtensions='extensions'
                    :multiple='false'></ejs-uploader>
    </div>
  </div>
</template>


<script>
  import ProgressBar from 'vue-simple-progress';
  import { EventBus } from '../../plugins/eventBus';
  export default {
    name: 'addPatchDialog',
    components: {
      ProgressBar
    },
    data() {
      return {
        extensions: '.zip',
        showProgressBar: false,
        progressVal: 0,
        progressText: '0%',
        versionShow: false,
        versionSource: [],
        brokenFlag:0,
        dataList:[]
      }
    },
    methods: {
      upButton() {
        let curAddFlag=0;
          for(var index in  document.getElementsByClassName('e-file-select-wrap')){
             let str = document.getElementsByClassName('e-file-select-wrap')[index].outerHTML;
             if(str.indexOf(this.extensions) !== -1){
              curAddFlag = index;
              break;
            }
             if(typeof(str)=="undefined"){
                  break;
             }
          }
        document
          .getElementsByClassName('e-file-select-wrap')[curAddFlag]
          .querySelector('button')
          .click();
        return false;
      },
      setCancel(param){
        this.brokenFlag = param;
      },
      async onFileSelect(args) {
        this.tryUtilFileLoaded();
      },
      tryUtilFileLoaded(){
        setTimeout(() => {
          try {
            this.clearCancelTempFile(); //清空temp文件下的内容
            const uploadPrefix = this.randomId();
            this.bigFileUpload(uploadPrefix);
          } catch (error) {
            this.tryUtilFileLoaded();
          }
        }, 100);
      },
      randomId() {
        const _temp = 'abcdefghijklmnopqrstuvwxyz';
        let randStr = '';
        for (let i = 0; i <= 8; i++) {
          randStr += _temp[Math.round(Math.random(1) * 26)];
        }
        return randStr;
      },
      getParam() {
        let type = 0;
        const file = this.$refs.file.ej2Instances.filesData[0];
        const param = {
          file: file['rawFile'],
          fileType:file['type'],
          type: type
        };
        return param;
      },
      eventEmit(type, content) {
        EventBus.$emit('toast', {type: type, content: content})
      },
      async bigFileUpload(uploadPrefix) {
        // 进度条
        this.brokenFlag = 0;
        const data = this.getParam();
        const srcFile = data['file'];
        // 如果文件为空，则退出
        if(!srcFile){
          this.eventEmit('warning', this.$t('System.fileNotNull'));
          return null;
        }
        if(data['fileType'] != 'zip'){
          this.eventEmit('warning', this.$t('DeployManagement.invalidPatch'));
          return;
        }
        document.getElementById("uploadBtnDivVM").style.display="none";
        EventBus.$emit("setChildPropsVMPatch", {status:0});
        const tempFiles = [];
        // 每片5M
        const perPiece = 1024 * 1024 * 50;
        let originalFilePath = '';
        let start = 0;
        let end = 0;
        let index = 0;
        let totalPieces = 0;
        let filesize = srcFile.size;
        let filename = srcFile.name;
        // 计算文件切片总数
        totalPieces = filesize % perPiece == 0 ? filesize/perPiece : filesize/perPiece + 1;
        // 上传文件
        const url = '/lte/ems/config/mml/recoverFilePiece';
        const config = {
          headers: {
            "Content-Type": "multipart/form-data"
          },
          processData: false,
          async: false,
          contentType: false,
          timeout: 60 * 30 * 1000
        };
        let pecent = 0;
        this.showProgressBar = true;
        while((start < filesize) && this.brokenFlag == 0) {
          // 切片上传
          end = start + perPiece;
          if(end > filesize) {
            // 一次性上传
            end = filesize;
          }
          // 分割文件核心部分slice
          const chunk = srcFile.slice(start, end);
          const formData = new FormData();
          formData.append("file", chunk, filename);
          formData.append("totalPieces", totalPieces);
          formData.append("index", index);
          formData.append("process", pecent);
          formData.append("prefix", uploadPrefix);
          await this.$axios.post(url, formData, config).then(response => {
            const result = response['data']['resultVal'];
            tempFiles.push(result['msg']);
            originalFilePath = result['message'];
            // // 进度条
            pecent=(100*(end)/filesize).toFixed(2);
            if(pecent>=100){
              pecent=100.00;
            }
            this.progressVal = pecent;
            this.progressText = pecent + '%';
          });
          start = end;
          index ++;
        }
        if(this.brokenFlag != 0){
          this.mergeBigFile(tempFiles, originalFilePath);
        }else{
          this.sendUpload(originalFilePath);
          //this.clearCancelTempFile(uploadPrefix);
        }
      },
      clearCancelTempFile(){
        const url = '/lte/ems/config/mml/clearTempPath';
        const param = {
          prefix: 0
        };
        this.$axios.post(url, param).then(res => {
          console.log("clear cancel tempFile...");
        });
      },
      mergeBigFile(tempFiles, originalFilePath) {
        const url = '/lte/ems/config/mml/mergeBigFile';
        const param = {
          tempFiles: tempFiles,
          originalFilePath: originalFilePath
        };
        this.progressText = this.$t('DeployManagement.mergeBigFile');
        this.$axios.post(url, param).then(res=> {
          if(res.data.errorCode == 'SUCCESS'){
            const data = this.getParam();
            if(data['fileType'] == "zip"){
              this.progressText = this.$t('System.processing');
              this.sendUpload(originalFilePath);
            }
          }else{
            this.progressText = res.data.errorString;
          }
          //EventBus.$emit("setChildPropsVMPatch", {status:1});
        });

      },
      sendUpload(originalFilePath){
        const url = '/lte/ems/config/mml/uploadRecoverZip';
        const param = {
          filePath: originalFilePath,
        };
        this.$axios.post(url, param, {timeout: 60 * 5 * 1000}).then(res => {
          if(res.data.errorCode == 'SUCCESS'){
            this.progressText = this.$t('DeployManagement.uploadFinish');
          }else{
            this.progressText = res.data.errorString;
          }
        });
      }
    },
    destroyed() {
      this.brokenFlag = 1;
    }
  }
</script>
